/**
 * Owner: Masa Bayu
 * File: MediaChromePanel.tsx
 * Date:Time: 2026-09-16 18:53
 * Description: T8-E4 Media chrome intent UI — packages only; QXReader executes.
 */

import { useId, useState } from 'react';
import {
  createDemoMediaIntent,
  getDemoAdvancedStatus,
  getDemoMediaIntent,
  resetDemoAdvancedStore,
} from './demo-advanced-store';

export interface MediaChromePanelProps {
  readonly onNavigate: (path: string) => void;
}

export function MediaChromePanel({ onNavigate }: MediaChromePanelProps) {
  const statusId = useId();
  const [status, setStatus] = useState(() => getDemoAdvancedStatus());
  const [intent, setIntent] = useState(() => getDemoMediaIntent());

  const refresh = (next: string) => {
    setStatus(next);
    setIntent(getDemoMediaIntent());
  };

  return (
    <section className="route-panel media-chrome" aria-labelledby="media-chrome-title">
      <h2 id="media-chrome-title">Media · chrome</h2>
      <p>QXRead packages Media chrome intents. Playback and captions execute in QXReader only.</p>
      <p id={statusId} role="status" aria-live="polite" className="media-chrome__status">
        {status}
        {intent !== null ? ` · kind ${intent.kind}` : ''}
      </p>
      <div role="group" aria-label="Media chrome actions" className="media-chrome__controls">
        <button
          type="button"
          onClick={() => {
            refresh(createDemoMediaIntent());
          }}
        >
          Package caption intent
        </button>
        <button
          type="button"
          onClick={() => {
            resetDemoAdvancedStore();
            refresh(getDemoAdvancedStatus());
          }}
        >
          Reset demo
        </button>
        <button
          type="button"
          onClick={() => {
            onNavigate('/offline');
          }}
        >
          PWA
        </button>
      </div>
      {intent !== null ? (
        <ul aria-label="Media chrome facts" className="media-chrome__facts">
          <li>{`executesInQxread=${String(intent.executesInQxread)}`}</li>
          <li>{`executesInQxReader=${String(intent.executesInQxReader)}`}</li>
          <li>{`inventsEntitlement=${String(intent.inventsEntitlement)}`}</li>
        </ul>
      ) : null}
    </section>
  );
}
